// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../Assets/background (original).png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --background-color: #FFFFFF;
  --border-color: #343A40FF;
  --hover-border-color: #1E2125FF;
  --button-background: #2E5288FF;
}

body {
  font-family: Arial, sans-serif;
  margin: 0;
}

.layout {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 1200px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center;
  background-size: cover;
}

.background-img {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.meddict-title {
  font-family: Montserrat, sans-serif;
  font-size: 32px;
  font-weight: 600;
  line-height: 48px;
  color: white;
  margin-top: 40px;
  margin-bottom: 40px;
}

.search-wrapper {
  position: relative;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  flex-grow: 1;
  width: 800px;
  height: 55px;
  font-family: Inter, sans-serif;
  font-size: 19px;
  font-weight: 400;
  line-height: 26px;
  background: var(--background-color);
  border: none;
  border-color: var(--border-color);
  outline: none;
  box-shadow: 0 5px 15px dimgrey;
  transition: width 0.1s ease-in-out;
  margin-bottom: 10px;
}

.language-search {
  position: relative;
  width: 120px;
  height: 55px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Inter, sans-serif;
  font-size: 19px;
  font-weight: 400;
  line-height: 26px;
  color: #FFFFFF;
  background: white;
  opacity: 1;
  border-right: 1px solid #BCC1CAFF;
  overflow: hidden;
  cursor: pointer;
}

.language-swap {
  font-family: Inter, sans-serif;
  color: #4d4f52;
  border: none;
  outline: none;
  cursor: pointer;
  width: 100%;
  height: 100%;
  font-size: 19px;
  text-align: center;
}

.meddict-search {
  position: relative;
  opacity: 1;
  margin-bottom: 35px;
  text-align: center;
  display: flex;
}

.meddict-search input {
  flex-grow: 1;
  padding: 0 10px;
  width: 400px;
  height: 55px;
  font-family: Inter, sans-serif;
  font-size: 19px;
  font-weight: 400;
  line-height: 26px;
  background: var(--background-color);
  border: none;
  border-color: var(--border-color);
  outline: none;
  transition: width 0.1s ease-in-out;
}

.meddict-search input:hover {
  background: var(--background-color);
  border-color: var(--hover-border-color);
}

.meddict-search input:focus {
  background: var(--background-color);
  border-color: var(--border-color);
}

.meddict-search ::placeholder {
  color: #BCC1CAFF;
}

.meddict-search input:disabled {
  color: #BCC1CAFF;
}

.meddict-button {
  position: relative;
  width: 60px;
  height: 55px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Inter, sans-serif;
  font-size: 19px;
  font-weight: 400;
  line-height: 26px;
  color: #FFFFFF;
  background: var(--button-background);
  opacity: 1;
  cursor: pointer;
  transition: background 0.3s, color 0.3s;
}

.meddict-button:hover {
  color: var(--button-background);
  background: white;
  border-color: var(--button-background);
  filter: brightness(120%);
  border-left: 1px solid gray;
}

.meddict-button:disabled {
  opacity: 0.4;
}

.meddict-button:hover .icon {
  color: var(--button-background);
}

.suggestions {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background-color: white;
  border-style: none;
  box-shadow: 0 3px 3px gray;
  display: none;
  z-index: 1;
  padding-bottom: 20px;
  font-size: 19px;
  overflow-y: auto;
  max-height: 350px;
}

.suggestion {
  cursor: pointer;
  text-align: left;
  padding: 10px 10px 10px 47px;
  transition: background-color 0.2s ease;
  overflow-y: auto;
}


.suggestions::-webkit-scrollbar-thumb {
  top: 100%;
  left: 0;
  right: 0;
  border-style: none;
  display: none;
  z-index: 1;
  padding-bottom: 20px;
}

.suggestions::-webkit-scrollbar-track {
  background-color: white;
  top: 100%;
  left: 0;
  right: 0;
  border-style: none;
  display: none;
  z-index: 1;
  padding-bottom: 20px;
}

.suggestion:hover {
  background-color: #d3d3d3;
  transition: background-color 0.2s ease;
}

.suggestion.selected {
  background-color: #d3d3d3;
}

.result-container {
  display: flex;
  flex-direction: row;
  width: 100%;
  max-width: 1200px;
  height: 450px;
  background: #1C468EFF;
  border-radius: 20px;
  box-shadow: 0 8px 17px #171a1f, 0 0 2px #171a1f;
  border: none;
  opacity: 0;
  transition: opacity 0.5s ease-in-out;
  margin-bottom: 35px;
}

.result-container.show {
  opacity: 1;
}

.result-left {
  flex: 1 1;
  display: flex;
  flex-direction: column;
}

.result-upper,
.result-lower {
  flex: 1 1;
  display: flex;
  align-items: center;
  border: none;
}

.sound-column {
  margin-right: 20px;
}

.result-card {
  flex: 1 1;
  max-width: 70%;
  border: none;
  color: white;
  text-align: left;
  font-family: Montserrat, sans-serif;
  font-size: 25px;
  font-weight: 700;
  line-height: 60px;
  opacity: 0;
  transform: translateY(20px);
  transition: opacity 0.5s ease-in-out, transform 0.5s ease-in-out;
}

.result-card.show {
  opacity: 1;
  transform: translateY(0);
}


.result-right {
  flex: 1 1;
  overflow: hidden;
}

.result-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  clip-path: polygon(0 0, 100% 0, 100% 100%, 0% 100%);
  border-radius: 0 20px 20px 0;
}

.no-image-text{
  color: white;
  text-align: center;
  font-family: Montserrat, sans-serif;
  font-size: 25px;
  font-weight: 700;
  line-height: 60px;
}

.line {
  width: 70%;
  height: 1px;
  background-color: #D29211FF;
  margin: 10px auto;
}

.sound-button {
  margin-left: 80px;
  width: 50px;
  height: 50px;
  background-color: #D32727FF;
  border-radius: 50%;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.sound-icon {
  width: 80%;
  height: 60%;
  fill: #FFFFFF;
}

.sound-button:hover {
  background-color: #FF0000FF;
}

.sound-button:active {
  background-color: #990000FF;
}


@media (max-width: 768px) {
  .meddict-search {
    width: 100%;
    max-width: 610px;
    margin: 0 auto;
  }

  .meddict-search input {
    width: 100%;
    max-width: 430px;
  }

  .result-container {
    flex-direction: column;
    height: auto;
    margin-top: 50px;
  }

  .result-left,
  .result-right {
    width: 100%;
  }

  .result-image {
    border-radius: 0;
  }

  .result-card {
    max-width: 100%;
  }
}

.button-container {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}



@media (max-width: 618px) {
  .meddict-search {
    width: 100%;
    max-width: 580px;
    margin: 0 auto;
  }

  .meddict-search input {
    width: 100%;
    max-width: 400px;
  }

  .result-container {
    flex-direction: column;
    height: auto;
    margin-top: 50px;
  }

  .result-left,
  .result-right {
    width: 100%;
  }

  .result-image {
    border-radius: 0;
  }

  .result-card {
    max-width: 100%;
  }
}

@media (max-width: 588px) {
  .meddict-search {
    width: 100%;
    max-width: 400px;
    margin: 0 auto;
  }

  .meddict-search input {
    width: 100%;
    max-width: 220px;
  }

  .result-container {
    flex-direction: column;
    height: auto;
    margin-top: 50px;
  }

  .result-left,
  .result-right {
    width: 100%;
  }

  .result-image {
    border-radius: 0;
  }

  .result-card {
    max-width: 100%;
  }
}

@media (max-width: 408px) {
  .meddict-search {
    width: 100%;
    max-width: 390px;
    margin: 0 auto;
  }

  .meddict-search input {
    width: 100%;
    max-width: 210px;
  }

  .result-container {
    flex-direction: column;
    height: auto;
    margin-top: 50px;
  }

  .result-left,
  .result-right {
    width: 100%;
  }

  .result-image {
    border-radius: 0;
  }

  .result-card {
    max-width: 100%;
  }
}

@media (max-width: 400px) {
  .meddict-search {
    width: 100%;
    max-width: 380px;
    margin: 0 auto;
  }

  .meddict-search input {
    width: 100%;
    max-width: 200px;
  }

  .result-container {
    flex-direction: column;
    height: auto;
    margin-top: 50px;
  }

  .result-left,
  .result-right {
    width: 100%;
  }

  .result-image {
    border-radius: 0;
  }

  .result-card {
    max-width: 100%;
  }
}



`, "",{"version":3,"sources":["webpack://./src/Styles/MeddictSearchBar.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,oEAA0E;EAC1E,sBAAsB;AACxB;;AAEA;EACE,yDAA+D;EAC/D,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;EACnC,YAAY;EACZ,iCAAiC;EACjC,aAAa;EACb,8BAA8B;EAC9B,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,UAAU;EACV,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,cAAc;EACd,YAAY;EACZ,aAAa;EACb,eAAe;EACf,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;EACnC,YAAY;EACZ,iCAAiC;EACjC,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,mCAAmC;EACnC,uCAAuC;AACzC;;AAEA;EACE,mCAAmC;EACnC,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,oCAAoC;EACpC,UAAU;EACV,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,sCAAsC;EACtC,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,uBAAuB;EACvB,kBAAkB;EAClB,0BAA0B;EAC1B,aAAa;EACb,UAAU;EACV,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,sCAAsC;EACtC,gBAAgB;AAClB;;;AAGA;EACE,SAAS;EACT,OAAO;EACP,QAAQ;EACR,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,+CAA+C;EAC/C,YAAY;EACZ,UAAU;EACV,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;AACxB;;AAEA;;EAEE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,UAAU;EACV,2BAA2B;EAC3B,gEAAgE;AAClE;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;;AAGA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mDAAmD;EACnD,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,aAAa;AACf;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;;AAGA;EACE;IACE,WAAW;IACX,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;EAClB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;;;AAIA;EACE;IACE,WAAW;IACX,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;EAClB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,WAAW;IACX,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;EAClB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,WAAW;IACX,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;EAClB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,WAAW;IACX,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;EAClB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[":root {\r\n  --background-color: #FFFFFF;\r\n  --border-color: #343A40FF;\r\n  --hover-border-color: #1E2125FF;\r\n  --button-background: #2E5288FF;\r\n}\r\n\r\nbody {\r\n  font-family: Arial, sans-serif;\r\n  margin: 0;\r\n}\r\n\r\n.layout {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  text-align: center;\r\n  height: 1200px;\r\n  background: url(\"../Assets/background\\ \\(original\\).png\") no-repeat center;\r\n  background-size: cover;\r\n}\r\n\r\n.background-img {\r\n  background-image: url('../Assets/background\\ \\(original\\).png');\r\n  background-size: cover;\r\n  background-position: center;\r\n  background-repeat: no-repeat;\r\n  height: 100vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.meddict-title {\r\n  font-family: Montserrat, sans-serif;\r\n  font-size: 32px;\r\n  font-weight: 600;\r\n  line-height: 48px;\r\n  color: white;\r\n  margin-top: 40px;\r\n  margin-bottom: 40px;\r\n}\r\n\r\n.search-wrapper {\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: row;\r\n  flex-wrap: wrap;\r\n  flex-grow: 1;\r\n  width: 800px;\r\n  height: 55px;\r\n  font-family: Inter, sans-serif;\r\n  font-size: 19px;\r\n  font-weight: 400;\r\n  line-height: 26px;\r\n  background: var(--background-color);\r\n  border: none;\r\n  border-color: var(--border-color);\r\n  outline: none;\r\n  box-shadow: 0 5px 15px dimgrey;\r\n  transition: width 0.1s ease-in-out;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.language-search {\r\n  position: relative;\r\n  width: 120px;\r\n  height: 55px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-family: Inter, sans-serif;\r\n  font-size: 19px;\r\n  font-weight: 400;\r\n  line-height: 26px;\r\n  color: #FFFFFF;\r\n  background: white;\r\n  opacity: 1;\r\n  border-right: 1px solid #BCC1CAFF;\r\n  overflow: hidden;\r\n  cursor: pointer;\r\n}\r\n\r\n.language-swap {\r\n  font-family: Inter, sans-serif;\r\n  color: #4d4f52;\r\n  border: none;\r\n  outline: none;\r\n  cursor: pointer;\r\n  width: 100%;\r\n  height: 100%;\r\n  font-size: 19px;\r\n  text-align: center;\r\n}\r\n\r\n.meddict-search {\r\n  position: relative;\r\n  opacity: 1;\r\n  margin-bottom: 35px;\r\n  text-align: center;\r\n  display: flex;\r\n}\r\n\r\n.meddict-search input {\r\n  flex-grow: 1;\r\n  padding: 0 10px;\r\n  width: 400px;\r\n  height: 55px;\r\n  font-family: Inter, sans-serif;\r\n  font-size: 19px;\r\n  font-weight: 400;\r\n  line-height: 26px;\r\n  background: var(--background-color);\r\n  border: none;\r\n  border-color: var(--border-color);\r\n  outline: none;\r\n  transition: width 0.1s ease-in-out;\r\n}\r\n\r\n.meddict-search input:hover {\r\n  background: var(--background-color);\r\n  border-color: var(--hover-border-color);\r\n}\r\n\r\n.meddict-search input:focus {\r\n  background: var(--background-color);\r\n  border-color: var(--border-color);\r\n}\r\n\r\n.meddict-search ::placeholder {\r\n  color: #BCC1CAFF;\r\n}\r\n\r\n.meddict-search input:disabled {\r\n  color: #BCC1CAFF;\r\n}\r\n\r\n.meddict-button {\r\n  position: relative;\r\n  width: 60px;\r\n  height: 55px;\r\n  padding: 0 16px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-family: Inter, sans-serif;\r\n  font-size: 19px;\r\n  font-weight: 400;\r\n  line-height: 26px;\r\n  color: #FFFFFF;\r\n  background: var(--button-background);\r\n  opacity: 1;\r\n  cursor: pointer;\r\n  transition: background 0.3s, color 0.3s;\r\n}\r\n\r\n.meddict-button:hover {\r\n  color: var(--button-background);\r\n  background: white;\r\n  border-color: var(--button-background);\r\n  filter: brightness(120%);\r\n  border-left: 1px solid gray;\r\n}\r\n\r\n.meddict-button:disabled {\r\n  opacity: 0.4;\r\n}\r\n\r\n.meddict-button:hover .icon {\r\n  color: var(--button-background);\r\n}\r\n\r\n.suggestions {\r\n  position: absolute;\r\n  top: 100%;\r\n  left: 0;\r\n  right: 0;\r\n  background-color: white;\r\n  border-style: none;\r\n  box-shadow: 0 3px 3px gray;\r\n  display: none;\r\n  z-index: 1;\r\n  padding-bottom: 20px;\r\n  font-size: 19px;\r\n  overflow-y: auto;\r\n  max-height: 350px;\r\n}\r\n\r\n.suggestion {\r\n  cursor: pointer;\r\n  text-align: left;\r\n  padding: 10px 10px 10px 47px;\r\n  transition: background-color 0.2s ease;\r\n  overflow-y: auto;\r\n}\r\n\r\n\r\n.suggestions::-webkit-scrollbar-thumb {\r\n  top: 100%;\r\n  left: 0;\r\n  right: 0;\r\n  border-style: none;\r\n  display: none;\r\n  z-index: 1;\r\n  padding-bottom: 20px;\r\n}\r\n\r\n.suggestions::-webkit-scrollbar-track {\r\n  background-color: white;\r\n  top: 100%;\r\n  left: 0;\r\n  right: 0;\r\n  border-style: none;\r\n  display: none;\r\n  z-index: 1;\r\n  padding-bottom: 20px;\r\n}\r\n\r\n.suggestion:hover {\r\n  background-color: #d3d3d3;\r\n  transition: background-color 0.2s ease;\r\n}\r\n\r\n.suggestion.selected {\r\n  background-color: #d3d3d3;\r\n}\r\n\r\n.result-container {\r\n  display: flex;\r\n  flex-direction: row;\r\n  width: 100%;\r\n  max-width: 1200px;\r\n  height: 450px;\r\n  background: #1C468EFF;\r\n  border-radius: 20px;\r\n  box-shadow: 0 8px 17px #171a1f, 0 0 2px #171a1f;\r\n  border: none;\r\n  opacity: 0;\r\n  transition: opacity 0.5s ease-in-out;\r\n  margin-bottom: 35px;\r\n}\r\n\r\n.result-container.show {\r\n  opacity: 1;\r\n}\r\n\r\n.result-left {\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.result-upper,\r\n.result-lower {\r\n  flex: 1;\r\n  display: flex;\r\n  align-items: center;\r\n  border: none;\r\n}\r\n\r\n.sound-column {\r\n  margin-right: 20px;\r\n}\r\n\r\n.result-card {\r\n  flex: 1;\r\n  max-width: 70%;\r\n  border: none;\r\n  color: white;\r\n  text-align: left;\r\n  font-family: Montserrat, sans-serif;\r\n  font-size: 25px;\r\n  font-weight: 700;\r\n  line-height: 60px;\r\n  opacity: 0;\r\n  transform: translateY(20px);\r\n  transition: opacity 0.5s ease-in-out, transform 0.5s ease-in-out;\r\n}\r\n\r\n.result-card.show {\r\n  opacity: 1;\r\n  transform: translateY(0);\r\n}\r\n\r\n\r\n.result-right {\r\n  flex: 1;\r\n  overflow: hidden;\r\n}\r\n\r\n.result-image {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n  clip-path: polygon(0 0, 100% 0, 100% 100%, 0% 100%);\r\n  border-radius: 0 20px 20px 0;\r\n}\r\n\r\n.no-image-text{\r\n  color: white;\r\n  text-align: center;\r\n  font-family: Montserrat, sans-serif;\r\n  font-size: 25px;\r\n  font-weight: 700;\r\n  line-height: 60px;\r\n}\r\n\r\n.line {\r\n  width: 70%;\r\n  height: 1px;\r\n  background-color: #D29211FF;\r\n  margin: 10px auto;\r\n}\r\n\r\n.sound-button {\r\n  margin-left: 80px;\r\n  width: 50px;\r\n  height: 50px;\r\n  background-color: #D32727FF;\r\n  border-radius: 50%;\r\n  border: none;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  cursor: pointer;\r\n}\r\n\r\n.sound-icon {\r\n  width: 80%;\r\n  height: 60%;\r\n  fill: #FFFFFF;\r\n}\r\n\r\n.sound-button:hover {\r\n  background-color: #FF0000FF;\r\n}\r\n\r\n.sound-button:active {\r\n  background-color: #990000FF;\r\n}\r\n\r\n\r\n@media (max-width: 768px) {\r\n  .meddict-search {\r\n    width: 100%;\r\n    max-width: 610px;\r\n    margin: 0 auto;\r\n  }\r\n\r\n  .meddict-search input {\r\n    width: 100%;\r\n    max-width: 430px;\r\n  }\r\n\r\n  .result-container {\r\n    flex-direction: column;\r\n    height: auto;\r\n    margin-top: 50px;\r\n  }\r\n\r\n  .result-left,\r\n  .result-right {\r\n    width: 100%;\r\n  }\r\n\r\n  .result-image {\r\n    border-radius: 0;\r\n  }\r\n\r\n  .result-card {\r\n    max-width: 100%;\r\n  }\r\n}\r\n\r\n.button-container {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  margin-top: 20px;\r\n}\r\n\r\n\r\n\r\n@media (max-width: 618px) {\r\n  .meddict-search {\r\n    width: 100%;\r\n    max-width: 580px;\r\n    margin: 0 auto;\r\n  }\r\n\r\n  .meddict-search input {\r\n    width: 100%;\r\n    max-width: 400px;\r\n  }\r\n\r\n  .result-container {\r\n    flex-direction: column;\r\n    height: auto;\r\n    margin-top: 50px;\r\n  }\r\n\r\n  .result-left,\r\n  .result-right {\r\n    width: 100%;\r\n  }\r\n\r\n  .result-image {\r\n    border-radius: 0;\r\n  }\r\n\r\n  .result-card {\r\n    max-width: 100%;\r\n  }\r\n}\r\n\r\n@media (max-width: 588px) {\r\n  .meddict-search {\r\n    width: 100%;\r\n    max-width: 400px;\r\n    margin: 0 auto;\r\n  }\r\n\r\n  .meddict-search input {\r\n    width: 100%;\r\n    max-width: 220px;\r\n  }\r\n\r\n  .result-container {\r\n    flex-direction: column;\r\n    height: auto;\r\n    margin-top: 50px;\r\n  }\r\n\r\n  .result-left,\r\n  .result-right {\r\n    width: 100%;\r\n  }\r\n\r\n  .result-image {\r\n    border-radius: 0;\r\n  }\r\n\r\n  .result-card {\r\n    max-width: 100%;\r\n  }\r\n}\r\n\r\n@media (max-width: 408px) {\r\n  .meddict-search {\r\n    width: 100%;\r\n    max-width: 390px;\r\n    margin: 0 auto;\r\n  }\r\n\r\n  .meddict-search input {\r\n    width: 100%;\r\n    max-width: 210px;\r\n  }\r\n\r\n  .result-container {\r\n    flex-direction: column;\r\n    height: auto;\r\n    margin-top: 50px;\r\n  }\r\n\r\n  .result-left,\r\n  .result-right {\r\n    width: 100%;\r\n  }\r\n\r\n  .result-image {\r\n    border-radius: 0;\r\n  }\r\n\r\n  .result-card {\r\n    max-width: 100%;\r\n  }\r\n}\r\n\r\n@media (max-width: 400px) {\r\n  .meddict-search {\r\n    width: 100%;\r\n    max-width: 380px;\r\n    margin: 0 auto;\r\n  }\r\n\r\n  .meddict-search input {\r\n    width: 100%;\r\n    max-width: 200px;\r\n  }\r\n\r\n  .result-container {\r\n    flex-direction: column;\r\n    height: auto;\r\n    margin-top: 50px;\r\n  }\r\n\r\n  .result-left,\r\n  .result-right {\r\n    width: 100%;\r\n  }\r\n\r\n  .result-image {\r\n    border-radius: 0;\r\n  }\r\n\r\n  .result-card {\r\n    max-width: 100%;\r\n  }\r\n}\r\n\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
